import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faPhoneSlash } from '@fortawesome/free-solid-svg-icons';
import './IncomingCallNotification.css'; // We'll create this file next
import AvatarImage from '../../ui/Avatar/AvatarImage';

interface IncomingCallNotificationProps {
    callerName: string;
    callerId : string;
    isMeeting?: boolean;
    onAccept: () => void;
    onReject: () => void;
    theme?: 'light' | 'dark';
}

const IncomingCallNotification: React.FC<IncomingCallNotificationProps> = ({
    callerName,
    callerId,
    isMeeting = false,
    onAccept,
    onReject,
    theme = 'light',
}) => {
    const message = isMeeting ? `${callerName} has started a meeting...` : `Incoming Call...`;

    return (
        <div className={`call-notification-container ${theme}`}>
            <div className="caller-info">
                <div className="caller-avatar">
                    {/* Placeholder for an avatar image - you can enhance this later */}
                    {/* <span className="avatar-initial">{callerName.charAt(0)}</span> */}
                    <span className="avatar-initial">
                        <AvatarImage
                            userId={callerId}
                            displayName={callerName}
                        />
                    </span>
                </div>
                <div className="caller-details">
                    <span className="call-status">{message}</span>
                    <span className="caller-name">{callerName}</span>
                </div>
            </div>
            <div className="call-actions">
                <button onClick={onAccept} className="action-button accept" aria-label="Accept call">
                    <FontAwesomeIcon icon={faPhone} />
                </button>
                <button onClick={onReject} className="action-button reject" aria-label="Reject call">
                    <FontAwesomeIcon icon={faPhoneSlash} />
                </button>
            </div>
        </div>
    );
};

export default IncomingCallNotification;
